function isDefined(val) {
  return val !== undefined && val !== null;
}
export default (function (obj) {
  let keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let toReturn;
  if (!isDefined(obj)) {
    toReturn = obj;
  } else {
    toReturn = Object.keys(obj).filter(key => !keysToOmit.includes(key)).reduce((result, key) => {
      const keyofT = key;
      result[keyofT] = obj[keyofT];
      return result;
    }, {});
  }
  return toReturn;
});
//# sourceMappingURL=omitKeys.js.map